
define('text!TescoMobile_Checkout/template/minicart/header-total.html',[],function () { return '<strong class="summary title" data-bind="i18n: \'Basket Total\'"></strong>';});

